/**
 * @module pages
 * @package @geenius/adapters/solidjs-solidui
 * @description Public SolidUI page wrappers for the SolidJS adapter reference
 * surface.
 */

import {
  type AdapterDetailPageProps,
  type AdaptersPageProps,
  AdapterDetailPage as ReferenceAdapterDetailPage,
  AdaptersPage as ReferenceAdaptersPage,
} from "@geenius/adapters/solidjs";
import type { JSX } from "solid-js";

export type { AdapterDetailPageProps, AdaptersPageProps };

export function AdapterDetailPage(props: AdapterDetailPageProps): JSX.Element {
  return <ReferenceAdapterDetailPage {...props} />;
}

export function AdaptersPage(props: AdaptersPageProps): JSX.Element {
  return <ReferenceAdaptersPage {...props} />;
}
